import { create } from 'zustand';
import { queryClient } from '../lib/queryClient';

interface SessionExpiredState {
  isOpen: boolean;
  showModal: () => void;
  hideModal: () => void;
}

export const useSessionExpiredStore = create<SessionExpiredState>((set) => ({
  isOpen: false,
  showModal: () => set({ isOpen: true }),
  hideModal: () => set({ isOpen: false }),
}));

const UNAUTH_ROUTES = [
  '/login',
  '/signup',
  '/forgot-password',
  '/reset-password',
  '/verify-email',
  '/unsubscribe',
];

export const handleSessionExpired = () => {
  if (typeof window === 'undefined') return;

  const pathname = window.location.pathname;
  if (UNAUTH_ROUTES.some((route) => pathname.startsWith(route))) {
    return;
  }

  // Reason: only surface the expired-session modal when a session actually
  // expired. A 401 from the initial /api/user probe (before the user has ever
  // authenticated in this tab) is the normal "not logged in" state, not an
  // expiration. The user query only holds a truthy value once we've seen an
  // authenticated response.
  const cachedUser = queryClient.getQueryData(['/api/user']);
  if (!cachedUser) return;

  const { isOpen, showModal } = useSessionExpiredStore.getState();
  if (isOpen) return;

  showModal();
};
